export const verifyMobileStepPhoneStyle = theme => ({
  root: {
    width: '100%',
  },

  phoneInputButton: {
    boxShadow: 'none',
    background: 'transparent',

    '&:hover': {
      backgroundColor: 'transparent',
      boxShadow: 'none',
    },

    '&:active': {
      boxShadow: 'none',
    },
  },
})
